import Button from '@material-ui/core/Button';
import { FC, useState } from 'react';

import { IAllocationClientsByGroup } from '~/services/api/clientAllocation/types';

import styles from '../ViewClientAllocation.module.scss';

interface IProps {
  groups: IAllocationClientsByGroup[];
  allocationId: number;
}

const LocationGroupClient: FC<IProps> = ({ groups, allocationId }) => {
  const [showClientsMore, setShowClientsMore] = useState(false);
  const [showGroupsMore, setShowGroupsMore] = useState(false);

  const maxAmountToShow = 3;

  return (
    <div className={styles.cell}>
      <div className={styles.cellWrapper}>
        {(showGroupsMore ? groups : groups.slice(0, maxAmountToShow)).map(group => {
          if (!group.clients?.length) {
            return null;
          }
          return (
            <div key={`location-group-${allocationId}-${group.locationGroup.id}`}>
              <strong className={styles.locationGroupName}>{`${group.locationGroup.name}:`}</strong>
              <div className={styles.clientNames}>
                {(showClientsMore
                  ? group.clients
                  : [...group.clients].splice(0, maxAmountToShow)
                ).map(client => (
                  <div key={client.id} className={styles.clientCell}>
                    <div className={styles.clientName}>{client.name}</div>
                    <div className={styles.memo}>{client.memo}</div>
                  </div>
                ))}
                {group.clients.length > maxAmountToShow && (
                  <Button
                    variant="text"
                    onClick={() => setShowClientsMore(prevState => !prevState)}
                    className={styles.showMoreButton}
                  >
                    {`${showClientsMore ? 'Hide' : 'Show'} More Clients`}
                  </Button>
                )}
              </div>
            </div>
          );
        })}
        {groups.length > maxAmountToShow && (
          <Button
            variant="text"
            onClick={() => setShowGroupsMore(prevState => !prevState)}
            className={styles.showMoreButton}
          >
            {`${showGroupsMore ? 'Hide' : 'Show'} More Location Groups`}
          </Button>
        )}
      </div>
    </div>
  );
};

export default LocationGroupClient;
